module.exports = __webpack_public_path__ + "static/media/20180607_165551.81252cce.jpg";